import React from "react";

const ProgressBar = ({ progress, progressContent, height,bgcolor}) => {
  return (
    <div
      style={{
        width: "100%",
        height: height,
        background: "#f0f0f0", 
        borderRadius: "25px",
        overflow: "hidden",
        position: "relative",
      }}
    >
      <div
        style={{
          height: "100%",
          width: `${progress}%`, 
          background: bgcolor,
          borderRadius: "25px", 
        }}
      >
        <span
          style={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            color: "#fff", 
            fontWeight: "bold",
          }}
        >
          {/* {progressContent} */}
        </span>
      </div>
    </div>
  );
};

export default ProgressBar;
